import {active} from "./const.js";
import $ from "jquery";

const $hamburger = $('#js-hamburger');
const $offcanvas = $('#js-offcanvas');
const $closeBtn = $('#js-offcanvasClose');
const $body = $('body');

$hamburger.add($closeBtn).on('click', function (){
  const isActive = $hamburger.hasClass(active);
  $hamburger.toggleClass(active);
  $offcanvas.toggleClass(active);
  $body.css('overflow', isActive ? 'visible' : 'hidden');
});

$(window).on('resize', function () {
  if($(window).width() >= 1360) {
    $hamburger.removeClass(active);
    $offcanvas.removeClass(active);
    $body.css('overflow', 'visible');
  }
});

$('.js-offcanvasNav').on('click', function (e) {
  e.preventDefault();
  const $this = $(this);
  const $localNav = $this.next('.js-offcanvasLocalNav');

  $localNav.slideToggle();
  $this.toggleClass(active);
});
